/* @flow */

import { Tr, Td } from 'components/UIKit/Table';

type ErrorSummaryRowProps = {
  children: any
}

export default function ErrorSummaryRow({
  children,
}: ErrorSummaryRowProps): React.Element {
  var descriptions = {
    critical: "Critical errors need to be resolved before harmonization can be requested.",
    warning: "Warning errors should be investigated, but may not require a fix before harmonization can be requested."
  }

  return (
    <Tr>
      <Td style={{ textTransform: 'capitalize' }}>{children.severity}</Td>
      <Td style={{ textAlign: 'right' }}>{children.count}</Td>
      <Td>{descriptions[children.severity.toLowerCase()] || ""}</Td>
    </Tr>
  );
}
